import React from 'react';

const SVG = ({ width = '12px', height = '12px', className = '', viewBox = '0 0 12 12', color = '#1D7EF0' }) => (
  <svg height={height} width={width} viewBox={viewBox} className={className}>
    <g id='workflow' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='side-bar-styles' transform='translate(-725.000000, -327.000000)' fill={color}>
        <g id='Group-8' transform='translate(479.000000, 0.000000)'>
          <g id='Group-6' transform='translate(0.000000, 240.000000)'>
            <g id='Group-45' transform='translate(91.000000, 0.000000)'>
              <g id='Group-5'>
                <g id='Group-8' transform='translate(15.000000, 77.000000)'>
                  <g id='Group-7' transform='translate(13.140000, 8.140000)'>
                    <g id='photo' transform='translate(127.600000, 2.220000)'>
                      <path
                        d='M9.62,8.55111111 L9.62,1.06888889 C9.62,0.481 9.139,0 8.55111111,0 L1.06888889,0 C0.481,0 0,0.481 0,1.06888889 L0,8.55111111 C0,9.139 0.481,9.62 1.06888889,9.62 L8.55111111,9.62 C9.139,9.62 9.62,9.139 9.62,8.55111111 L9.62,8.55111111 Z M2.93944444,5.61166667 L4.27555556,7.215 L6.14611111,4.81 L8.55111111,8.01666667 L1.06888889,8.01666667 L2.93944444,5.61166667 L2.93944444,5.61166667 Z'
                        id='Shape'
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SVG;
